const PageAgentMatch = () => {
 

  return (
    <div className="container pt-14 sm:pt-20 pb-24 lg:pb-32">
      <div className="space-y-6 sm:space-y-8">
        <div>
          <h2 className="text-3xl font-semibold">Agent Match Details</h2>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

      </div>
      
    </div>
  );
};


export default (
    PageAgentMatch
);
